import React from "react";
import { color, radius } from "../../styles/theme";

/**
 * Quick-action tile — icon + label, used for the action-grid pattern (Event
 * Details' Gallery/QR/Invite/etc row). Replaces the old giant-emoji-in-a-box
 * tiles with a real lucide icon in a tinted badge.
 */
const IconTile = ({ icon: Icon, label, onClick, tone = "primary" }) => {
  const tint = TINTS[tone] || TINTS.primary;
  return (
    <button type="button" className="icon-tile" onClick={onClick} style={s.tile}>
      <span style={{ ...s.iconBadge, background: tint.bg, color: tint.fg }}>
        <Icon size={19} strokeWidth={2} />
      </span>
      <span style={s.label}>{label}</span>
    </button>
  );
};

const TINTS = {
  primary: { bg: color.primary50, fg: color.primary600 },
  success: { bg: color.success50, fg: color.success700 },
  info: { bg: color.info50, fg: color.info500 },
  warning: { bg: color.warning50, fg: color.warning500 },
  neutral: { bg: color.gray100, fg: color.gray700 },
};

const s = {
  tile: {
    flex: "1 1 140px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    padding: "18px 12px",
    borderRadius: radius.md,
    border: `1px solid ${color.border}`,
    background: color.surface,
    cursor: "pointer",
  },
  iconBadge: {
    width: 38,
    height: 38,
    borderRadius: radius.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  label: { fontSize: 12.5, fontWeight: 600, color: color.textPrimary },
};

export default IconTile;
